/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
/**
 * SVG icon component.
 */
export function Trashcan({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g fill="currentColor" clipPath="url(#Trashcan_svg__a)"><path d="M6.25 5.9a.6.6 0 0 1 .6.6v5a.6.6 0 1 1-1.2 0v-5a.6.6 0 0 1 .6-.6M10.35 6.5a.6.6 0 1 0-1.2 0v5a.6.6 0 1 0 1.2 0z" /><path fillRule="evenodd" d="M6.134.4a1.6 1.6 0 0 0-1.497 1.035L4.085 2.9H1a.6.6 0 0 0 0 1.2h.95l.793 9.125a2.6 2.6 0 0 0 2.59 2.375h5.333a2.6 2.6 0 0 0 2.59-2.375L14.05 4.1H15a.6.6 0 1 0 0-1.2h-3.094l-.598-1.494A1.6 1.6 0 0 0 9.824.4zm5.352 3.7h1.36l-.785 9.021a1.4 1.4 0 0 1-1.395 1.279H5.334a1.4 1.4 0 0 1-1.395-1.279L3.154 4.1h8.332m-.872-1.2-.42-1.049a.4.4 0 0 0-.371-.251H6.134a.4.4 0 0 0-.374.259L5.367 2.9z" clipRule="evenodd" /></g><defs><clipPath id="Trashcan_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;